var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "purchase-dialog",
          staticStyle: { margin: "0 auto" },
          attrs: {
            "append-to-body": "",
            title: _vm.$t("purchaseOrder.title"),
            visible: _vm.isShowPurchase,
            "before-close": _vm.purchaseClose,
            width: "90%"
          }
        },
        [
          _c(
            "el-carousel",
            {
              ref: "dialog",
              staticClass: "picsCard",
              attrs: {
                arrow: "always",
                autoplay: false,
                "indicator-position": "outside",
                trigger: "click"
              },
              on: { change: _vm.dialogchange }
            },
            _vm._l(_vm.purchaseorder, function(item, index) {
              return _c(
                "el-carousel-item",
                { key: item + index, attrs: { label: item.custname } },
                [
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "90%", margin: "0 auto" },
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeName,
                        callback: function($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("purchaseOrder.purchasetabs[0]"),
                            name: "first"
                          }
                        },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "item",
                              refInFor: true,
                              staticClass: "demo-shopform",
                              staticStyle: {
                                overflow: "hidden",
                                "overflow-y": "scroll",
                                height: "550px"
                              },
                              attrs: {
                                model: item,
                                inline: true,
                                "label-width": "145px"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("subscribe.labellist[3]"),
                                    prop: "num"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: item.num,
                                      callback: function($$v) {
                                        _vm.$set(item, "num", $$v)
                                      },
                                      expression: "item.num"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("subscribe.labellist[6]"),
                                    prop: "custname"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: item.custname,
                                      callback: function($$v) {
                                        _vm.$set(item, "custname", $$v)
                                      },
                                      expression: "item.custname"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              false
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("subscribe.labellist[2]"),
                                        prop: "applydt"
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          "value-format": "yyyy-MM-dd",
                                          type: "date",
                                          disabled: ""
                                        },
                                        model: {
                                          value: item.applydt,
                                          callback: function($$v) {
                                            _vm.$set(item, "applydt", $$v)
                                          },
                                          expression: "item.applydt"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("subscribe.labellist[16]"),
                                    prop: "ShipmanDate",
                                    rules: {
                                      required: true,
                                      message:
                                        _vm.$t("subscribe.labellist[16]") +
                                        " " +
                                        _vm.$t("depart.msg[1]")
                                    }
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    style:
                                      item.status == 1 &&
                                      item.purchaseState == 0
                                        ? "width: 135px;"
                                        : "width: 200px;",
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      disabled: _vm.isLooka == true,
                                      type: "date"
                                    },
                                    model: {
                                      value: item.ShipmanDate,
                                      callback: function($$v) {
                                        _vm.$set(item, "ShipmanDate", $$v)
                                      },
                                      expression: "item.ShipmanDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  item.status == 1 && item.purchaseState == 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.checkDate(item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t("purchase.condition[1]")
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("purchase.tablelist[5]"),
                                    rules: {
                                      required: true,
                                      message:
                                        _vm.$t("purchase.tablelist[5]") +
                                        " " +
                                        _vm.$t("depart.msg[1]")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        disabled: _vm.isLooka == true,
                                        placeholder: _vm.$t(
                                          "SupplierClass.placeholder"
                                        )
                                      },
                                      model: {
                                        value: item.Payment,
                                        callback: function($$v) {
                                          _vm.$set(item, "Payment", $$v)
                                        },
                                        expression: "item.Payment"
                                      }
                                    },
                                    _vm._l(_vm.paymentList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.PaymentName,
                                          value: item.PaymentName
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("purchase.tablelist[3]")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: item.money,
                                      callback: function($$v) {
                                        _vm.$set(item, "money", $$v)
                                      },
                                      expression: "item.money"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              false
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("purchase.tablelist[17]")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          type: "number",
                                          max: "20",
                                          min: "0",
                                          disabled: _vm.isLooka == true
                                        },
                                        model: {
                                          value: item.VatRate,
                                          callback: function($$v) {
                                            _vm.$set(item, "VatRate", $$v)
                                          },
                                          expression: "item.VatRate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("purchase.tablelist[21]")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: item.Tax,
                                      callback: function($$v) {
                                        _vm.$set(item, "Tax", $$v)
                                      },
                                      expression: "item.Tax"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("purchase.tablelist[18]")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: item.totalAmount,
                                      callback: function($$v) {
                                        _vm.$set(item, "totalAmount", $$v)
                                      },
                                      expression: "item.totalAmount"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("purchase.tablelist[4]")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      disabled: item.purchaseState >= 1
                                    },
                                    on: {
                                      blur: function($event) {
                                        return _vm.discountInput(item)
                                      }
                                    },
                                    model: {
                                      value: item.discount,
                                      callback: function($$v) {
                                        _vm.$set(item, "discount", $$v)
                                      },
                                      expression: "item.discount"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("subscribe.labellist[7]"),
                                    rules: {
                                      required: true,
                                      message: _vm.$t("subscribe.errmsg[1]")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        disabled: _vm.isLooka == true,
                                        placeholder: _vm.$t(
                                          "SupplierClass.placeholder"
                                        )
                                      },
                                      on: { change: _vm.currencyChange },
                                      model: {
                                        value: item.currencyid,
                                        callback: function($$v) {
                                          _vm.$set(item, "currencyid", $$v)
                                        },
                                        expression: "item.currencyid"
                                      }
                                    },
                                    _vm._l(_vm.currlist, function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.ShortEng,
                                          value: item.id
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("GoodsList.dialog[14]")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: item.purclass,
                                      callback: function($$v) {
                                        _vm.$set(item, "purclass", $$v)
                                      },
                                      expression: "item.purclass"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isEdita == true
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("subscribe.labellist[0]")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: item.optname,
                                          callback: function($$v) {
                                            _vm.$set(item, "optname", $$v)
                                          },
                                          expression: "item.optname"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isEdita == false
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("subscribe.labellist[0]")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.base_name,
                                          callback: function($$v) {
                                            _vm.base_name = $$v
                                          },
                                          expression: "base_name"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("subscribe.labellist[4]"),
                                    prop: "explain"
                                  }
                                },
                                [
                                  _vm.isLooka == false
                                    ? _c("el-input", {
                                        staticStyle: { width: "555px" },
                                        attrs: { type: "textarea" },
                                        model: {
                                          value: item.explain,
                                          callback: function($$v) {
                                            _vm.$set(item, "explain", $$v)
                                          },
                                          expression: "item.explain"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isLooka == true
                                    ? _c("el-input", {
                                        staticStyle: { width: "555px" },
                                        attrs: {
                                          type: "textarea",
                                          disabled: ""
                                        },
                                        model: {
                                          value: item.explain,
                                          callback: function($$v) {
                                            _vm.$set(item, "explain", $$v)
                                          },
                                          expression: "item.explain"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formtable",
                                  staticStyle: { width: "100%" },
                                  attrs: { label: "" }
                                },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "empty-text": _vm.$t(
                                          "header.tableEmpty"
                                        ),
                                        stripe: "",
                                        border: "",
                                        data: item.GoodsList
                                      }
                                    },
                                    [
                                      _c(
                                        "el-table-column",
                                        {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.filesOut(
                                                                  item.GoodsList
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "GoodsList.filesout"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "subscribe.labellist[9]"
                                              ),
                                              width: "100",
                                              prop: "Goods.num",
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            cursor: "pointer",
                                                            color: "#409EFF",
                                                            "text-decoration":
                                                              "underline"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleCellClick(
                                                                scope.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.Goods
                                                                .num
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "subscribe.labellist[10]"
                                              ),
                                              width: "100",
                                              prop: "Goods.name",
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "subscribe.labellist[36]"
                                              ),
                                              width: "100",
                                              prop: "Goods.localDes",
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "subscribe.labellist[17]"
                                              ),
                                              width: "100",
                                              prop: "BaseCount",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "subscribe.labellist[11]"
                                              ),
                                              width: "100",
                                              prop: "count"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _vm.isLooka == false
                                                        ? _c("el-input", {
                                                            staticStyle: {
                                                              width: "100%"
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              min: "1"
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row.count,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  scope.row,
                                                                  "count",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "scope.row.count"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.isLooka == true
                                                        ? _c("el-input", {
                                                            staticStyle: {
                                                              width: "100%"
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              disabled: "",
                                                              min: "1"
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row.count,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  scope.row,
                                                                  "count",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "scope.row.count"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              width: "140",
                                              label: _vm.$t(
                                                "subscribe.labellist[19]"
                                              ),
                                              prop: "requestReason",
                                              "show-overflow-tooltip": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _vm.isLooka == false
                                                        ? _c("el-input", {
                                                            staticStyle: {
                                                              width: "100%"
                                                            },
                                                            attrs: {
                                                              type: "text"
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .requestReason,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  scope.row,
                                                                  "requestReason",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "scope.row.requestReason"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.isLooka == true
                                                        ? _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .requestReason
                                                              )
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "subscribe.labellist[12]"
                                              ),
                                              prop: "Goods.unit",
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "GoodsList.dialog[4]"
                                              ),
                                              width: "110",
                                              prop: "price",
                                              formatter: _vm.tableFormat,
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          disabled:
                                                            item.status != 0,
                                                          min: "0"
                                                        },
                                                        on: {
                                                          blur: _vm.changePrice
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.price,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "price",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.price"
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "purchase.tablelist[3]"
                                              ),
                                              width: "110",
                                              prop: "totalAmount",
                                              formatter: _vm.tableFormat,
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "purchase.tablelist[17]"
                                              ),
                                              width: "110",
                                              prop: "VatRate",
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _vm.isLooka == false
                                                        ? _c("el-input", {
                                                            staticStyle: {
                                                              width: "100%"
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              min: "0",
                                                              max: "20"
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .VatRate,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  scope.row,
                                                                  "VatRate",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "scope.row.VatRate"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.isLooka == true
                                                        ? _c("el-input", {
                                                            staticStyle: {
                                                              width: "100%"
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              disabled: "",
                                                              min: "0",
                                                              max: "20"
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .VatRate,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  scope.row,
                                                                  "VatRate",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "scope.row.VatRate"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "purchase.tablelist[21]"
                                              ),
                                              formatter: _vm.tableFormat,
                                              width: "100",
                                              prop: "Tax",
                                              "show-overflow-tooltip": "",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              label: _vm.$t(
                                                "GoodsList.dialog[21]"
                                              ),
                                              width: "120",
                                              prop: "Goods.NeedInspect",
                                              "show-overflow-tooltip": ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              label: _vm.$t(
                                                "purchase.tablelist[19]"
                                              ),
                                              width: "120",
                                              prop: "PQInfo",
                                              "show-overflow-tooltip": ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              label: _vm.$t(
                                                "purchase.tablelist[20]"
                                              ),
                                              width: "100",
                                              prop: "FromDepart",
                                              "show-overflow-tooltip": ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.isdeleteitem == true
                                            ? _c("el-table-column", {
                                                attrs: { width: "100" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "primary",
                                                                disabled:
                                                                  item.GoodsList
                                                                    .length <= 1
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.deleteItemFunc(
                                                                    scope.row,
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "GoodsList.deleteitem"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.id === 0 || item.id === null
                                            ? _c("el-table-column", {
                                                attrs: { width: "100" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "primary",
                                                                disabled:
                                                                  item.GoodsList
                                                                    .length <= 1
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.deleteItemBeforeCreate(
                                                                    scope.row,
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "GoodsList.deleteitem"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("purchaseOrder.purchasetabs[1]"),
                            name: "second"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "showText",
                            staticStyle: {
                              width: "100%",
                              "white-space": "pre-wrap"
                            },
                            attrs: {
                              type: "textarea",
                              disabled: "",
                              autosize: { minRows: 5, maxRows: 30 }
                            },
                            domProps: { innerHTML: _vm._s(item.remark) },
                            model: {
                              value: item.remark,
                              callback: function($$v) {
                                _vm.$set(item, "remark", $$v)
                              },
                              expression: "item.remark"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isEdita == true
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: _vm.$t("purchaseOrder.purchasetabs[2]"),
                                name: "third"
                              }
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "uploadc",
                                  staticStyle: {
                                    display: "flex",
                                    width: "auto"
                                  },
                                  attrs: {
                                    action: _vm.uploadFileURL,
                                    data: _vm.uploadData,
                                    "show-file-list": false,
                                    "on-remove": _vm.filesChange,
                                    "on-preview": _vm.clickFiles,
                                    "on-success": _vm.filesSuccess,
                                    "before-remove": _vm.fileDelete,
                                    disabled: _vm.isLooka == true
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-around",
                                        height: "100%"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "align-items": "center",
                                            "flex-direction": "column",
                                            "margin-top": "20px"
                                          }
                                        },
                                        [
                                          _vm.isLooka == false
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "GoodsList.dialog[11]"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "uploadTable",
                                          staticStyle: {
                                            width: "65%",
                                            margin: "auto 0",
                                            height: "100%",
                                            overflow: "hidden",
                                            "overflow-y": "scroll"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "empty-text": _vm.$t(
                                                  "header.tableEmpty"
                                                ),
                                                data: item.attachList,
                                                stripe: "",
                                                "show-header": false
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "name" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "10px",
                                                                "font-size":
                                                                  "15px"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .filename
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-circle-check",
                                                            staticStyle: {
                                                              color: "#67C23A"
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: { prop: "download" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c(
                                                            "el-link",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "15px"
                                                              },
                                                              attrs: {
                                                                type: "primary",
                                                                icon:
                                                                  "el-icon-download"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.clickFiles(
                                                                    scope.row
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "GoodsList.dialog[12]"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("purchaseOrder.purchasetabs[3]"),
                            name: "fourth"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "showText",
                            staticStyle: {
                              width: "100%",
                              "white-space": "pre-wrap"
                            },
                            attrs: {
                              type: "textarea",
                              disabled: "",
                              autosize: { minRows: 5, maxRows: 30 }
                            },
                            domProps: { innerHTML: _vm._s(item.operaHistory) },
                            model: {
                              value: item.operaHistory,
                              callback: function($$v) {
                                _vm.$set(item, "operaHistory", $$v)
                              },
                              expression: "item.operaHistory"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "flex-end" } },
            [
              _vm.isLooka == false
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitShop("item")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("GoodsList.submitBtn")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isnotify == true && _vm.isLooka == true
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.audit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("audit.buttons[1]")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("picture-swiper", {
        attrs: {
          filesList: _vm.currentGoods.picsList,
          showPreview: _vm.isShowPreview
        },
        on: {
          "update:filesList": function($event) {
            return _vm.$set(_vm.currentGoods, "picsList", $event)
          },
          "update:files-list": function($event) {
            return _vm.$set(_vm.currentGoods, "picsList", $event)
          },
          "update:showPreview": function($event) {
            _vm.isShowPreview = $event
          },
          "update:show-preview": function($event) {
            _vm.isShowPreview = $event
          },
          closeSwiper: _vm.FcloseSwiper
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a09b70f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a09b70f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PurchasingManagement/AddPurchaseOrder.vue
// module id = null
// module chunks = 